import { createContext, useContext, useState, useCallback } from 'react';

const EmailContext = createContext(null);

export const EmailContextProvider = ({
  children,
  initialRealty = null,
  initialClient = null,
  requestId = null,
}) => {
  const [selectedRealties, setSelectedRealties] = useState(
    initialRealty ? [initialRealty] : []
  );
  const [client, setClient] = useState(initialClient);
  const [activeRequestId, setActiveRequestId] = useState(requestId);

  const addRealty = useCallback(realty => {
    setSelectedRealties(prev => {
      if (prev.some(r => r.id === realty.id)) return prev;
      return [...prev, realty];
    });
  }, []);

  const removeRealty = useCallback(id => {
    setSelectedRealties(prev => prev.filter(r => r.id !== id));
  }, []);

  return (
    <EmailContext.Provider
      value={{
        selectedRealties,
        addRealty,
        removeRealty,
        client,
        setClient,
        requestId: activeRequestId,
        setRequestId: setActiveRequestId,
      }}
    >
      {children}
    </EmailContext.Provider>
  );
};

export const useEmailContext = () => {
  const ctx = useContext(EmailContext);
  if (!ctx) throw new Error('useEmailContext must be used inside EmailContextProvider');
  return ctx;
};
